import type { RefObject } from 'react';

import { useEventListener } from './useEventListener.tsx';

export const useClickOutside = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T | null>,
  handler: (event: MouseEvent) => void,
) => {
  const listener = (event: MouseEvent) => {
    const el = ref?.current;
    if (!el || el.contains(event.target as Node)) {
      return;
    }
    handler(event);
  };
  useEventListener('mousedown', listener);
};
